import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'

import { provideMarkdown } from 'ngx-markdown'

import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideSocketInitializer } from '@yoshu-lib/core/socket/socket-initializer.factory'

import { provideMarkdownCustomRenderer } from '@coty/core/config/marked-options.provider'
import { provideTranslate } from '@coty/core/config/translate.provider'
import { authInterceptor } from '@coty/core/http/auth.interceptor'
import { errorInterceptor } from '@coty/core/http/error.interceptor'

import { environment } from '@coty/env/environment'

import { routes } from './app.routes'
import { provideCore } from './core/core.providers'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideMarkdown(),
    provideMarkdownCustomRenderer(),
    provideTranslate(),
    provideIconsInitializer(),
    provideSocketInitializer(),

    ...provideCore()
  ]
}
